import { Injectable, Injector } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { filter, take, Subscription } from 'rxjs';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { CustomSnackbarComponent } from '../../shared/components/custom-snackbar/custom-snackbar.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private overlayRef?: OverlayRef;
  private componentRef?: CustomSnackbarComponent;
  routerSubscription: Subscription = new Subscription();
  previousQueryParams: any;
  currentRoute: string = "";

  constructor(
    private overlay: Overlay,
    private injector: Injector,
    private router: Router,
    private route: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.subscribeToRouteChanges()
  }

  private isMobile(): boolean {
    return this.breakpointObserver.isMatched(Breakpoints.Handset);
  }

  private subscribeToRouteChanges() {
    const navSub = this.router.events
      .pipe(filter((event: any) => event instanceof NavigationStart))
      .subscribe((res) => {
        this.currentRoute = this.router.url.split('?')[0].split('/').slice(1, 3).join('/');
        console.log("triggered by nav sub")
        this.onCloseAllSnackbar(res);
      });

    // commented for PAACAP. We do not use mode here. this causes multiple calls in the snack bar
    // const paramSub = this.route.paramMap.subscribe(() => {
    //   this.onCloseAllSnackbar(null);
    //    console.log("triggered by param sub")
    // });

    const queryParamSub = this.route.queryParamMap.subscribe((queryParams) => {
      if ((this.previousQueryParams && this.previousQueryParams.get('mode') == 'edit') ||
        this.previousQueryParams && this.previousQueryParams.get('mode') == 'add') {
        this.previousQueryParams = queryParams;
        return;
      }
      this.onCloseAllSnackbar(null);
      this.previousQueryParams = queryParams;
       console.log("triggered by query sub")
    });

    this.routerSubscription.add(navSub);
    // this.routerSubscription.add(paramSub);
    this.routerSubscription.add(queryParamSub);
  }

  public onCloseAllSnackbar(res: any) {
    if (!res) {
      this.closeAllSnackbar();
      return;
    }

    let url = res.url.split('?')[0].split('/').slice(1, 3).join('/');
    let persist =
      this.currentRoute.includes('change-password') || url.includes('login');

    if (this.currentRoute != url && !persist) {
      this.closeAllSnackbar();
    }
  }

  private attachSnackbar(): void {
    if (!this.overlayRef) {
      const position = this.isMobile()
        ? this.overlay.position().global().top('20px').centerHorizontally()
        : this.overlay.position().global().top('20px').right('20px');

      this.overlayRef = this.overlay.create({
        positionStrategy: position,
        hasBackdrop: false,
        panelClass: 'custom-snackbar-overlay',
      });

      const portal = new ComponentPortal(
        CustomSnackbarComponent,
        null,
        this.injector,
      );
      const componentRef = this.overlayRef.attach(portal);
      this.componentRef = componentRef.instance;

      this.componentRef.allMessagesCleared.pipe(take(1)).subscribe(() => {
        setTimeout(() => this.disposeSnackbar(), 500);
      });
    }
  }

  private disposeSnackbar(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = undefined;
      this.componentRef = undefined;
    }
  }

  show(message: string, action: string = 'Close', duration: number = 5000) {
    this.attachSnackbar();
    this.componentRef?.addMessage(message, action, duration);
  }

  closeAllSnackbar(): void {
    this.componentRef?.closeAllSnackbar();
  }
}
